import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { DeviceSetting, Recognition, RecognitionFilter } from '../../models';
import { DomSanitizer } from '@angular/platform-browser';
import { OverlayPanel } from 'primeng/overlaypanel';
import 'rxjs/Rx';
import { LprService } from '../../services';
import * as globals from '../../globals';
import { Table } from 'primeng/table';


@Component({
    selector: 'app-lpr',
    templateUrl: './lpr.component.html',
    styleUrls: ['./lpr.component.css']
})
export class LprComponent implements OnInit {

    recognitions: Recognition[];
    devices: DeviceSetting[];
    filter: RecognitionFilter;
    selectedDevices: DeviceSetting[];
    imageToShow: any;
    plateImageToShow: any;
    devicesMap: Map<number, DeviceSetting>;
    limit: number = 10;
    @ViewChild('dt', { static: true }) table: Table;
    pl = globals.pl;

    constructor(
        private lprService: LprService,
        public sanitizer: DomSanitizer
    ) { }

    ngOnInit() {
        this.filter = new RecognitionFilter();
        this.filter.startDate = new Date();
        this.filter.startDate.setHours(0, 0, 0, 0);
        this.selectedDevices = new Array();
        this.devicesMap = new Map<number, DeviceSetting>();
        this.lprService.getDeviceSettings().subscribe(data => {
            this.devices = data;
            this.devices.forEach(data => {
                this.devicesMap.set(data.id, data);
            });
            console.log("devicesMap ", this.devicesMap, this.devicesMap.get(1));
        });
    }

    search() {
        this.filter.lines = this.selectedDevices.map(data => data.id);

        let oldSize = 0;
        if (this.recognitions) {
            oldSize = this.recognitions.length;
        }
        this.lprService.searchRecognitions(this.filter)
            .subscribe(data => {
                this.recognitions = data;
                if ((oldSize / this.limit) > this.recognitions.length / this.limit) {
                    this.table.reset();
                }
            });
    }

    showImage(event, recognition: Recognition, overlayPanel: OverlayPanel) {
        this.imageToShow = null;
        this.plateImageToShow = null;
        this.lprService.loadImage(recognition.id).subscribe(data => {
            this.createImageFromBlob(data, (res) => { this.imageToShow = res });
        }, error => {
            console.log(error);
        });
        this.lprService.loadPlateImage(recognition.id).subscribe(data => {
            if (data != null) {
                this.createImageFromBlob(data, (res) => { this.plateImageToShow = res });
            }
        }, error => {
            console.error(error);
        });

        overlayPanel.toggle(event);
    }

    createImageFromBlob(image: Blob, res: Function) {
        let reader = new FileReader();
        reader.addEventListener("load", () => {
            res(reader.result);
        }, false);

        if (image && image.size > 0) {
            reader.readAsDataURL(image);
        }
    }

    downloadFile(): void {
        this.filter.lines = this.selectedDevices.map(data => data.id);
        this.lprService.getReportFile(this.filter).subscribe(data => {
            let file = new Blob([data], { type: 'application/xls' })
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file, "report.xlsx");
            }
            else {
                let url = URL.createObjectURL(file);
                window.open(url, "report.xlsx");
            }
        }, error => console.log("Error downloading file: " + error), () => console.log("downaloadFile OK"));
    }
}

